export const FEATURE_FLAG = {
  risebinar: false,
  proclass: false,
  bootcamp: true,
  video_course: true,
  digital_product: true,
  hire_graduates: true,
  corporate_training: true,
  community: true,
  career: true,
  blog: true,
}
